angular.module('impactx.login')
    .controller('PasswordResetController', ['LoginService', 'cookieService', '$mdDialog', '$listCache', '$scope', 'AppConfiguration', PasswordResetController])
    .controller('PasswordResetDialogController', ['LoginService', 'dataGen', 'cookieService', '$scope', 'themeFactory', PasswordResetDialogController])
    .controller('DirectLogoutController', ['LoginService', DirectLogoutController]);

function PasswordResetController(LoginService, cookieService, $mdDialog, $listCache, $scope, AppConfiguration) {
    var vm = this;
    cookieService.removeCookie("loginPage");

    $scope.currentYear = AppConfiguration.get('copyRightYear');
    $scope.removeCopyRight = AppConfiguration.get('removeCopyRight');

    this.logout = function () {
        LoginService.logout();
    };

    this.redirectToPasswordReset = function () {
        $listCache.removeAll();
        $mdDialog.hide();

        $mdDialog.show({
            templateUrl: './modules/login/templates/resetpw.html',
            controller: 'PasswordResetDialogController',
            controllerAs: "pwResetCtrl",
            clickOutsideToClose: false,
            escapeToClose: false,
            fullscreen: false
        });
    };

    vm.redirectToPasswordReset();
}

function DirectLogoutController(LoginService) {
    LoginService.logout();
}

function PasswordResetDialogController(LoginService, dataGen, cookieService, $scope, themeFactory) {
    cookieService.removeCookie("loginPage");
    $scope.theme = themeFactory.getTheme();

    var vm = this;

    vm.model = {};
    vm.trns = {};

    vm.model.passwordChange = {
        userName: {
            value: LoginService.getLastLoginName()
        }
    };

    this.logout = function () {
        LoginService.logout();
    };

    this.save = function () {
        var paramsObj = {
                data: vm.model
            };

        dataGen.post({}, paramsObj, "/user/password/save").then(
            function (data) {
                if (data.data.passwordChange == null || data.data.passwordChange == undefined)
                {
                    LoginService.closeDialogAndNavigateToLogin();
                }
                else
                {
                    vm.model = data.data;
                }
            }
        );
    };

    dataGen.getData({}, {}, "/user/password/view").then(function (data) {
        if (data && data.data) {
            vm.model = data.data;
            vm.trns = data.trns;
        }
    });
}

